import { useState, useEffect } from 'react';
import './RecentActivities.css';
import countallstatus from "../../apis/countallstatusforrequitionforcandidates/countallstatusforrequitionforcandidates";
import { NotificationContainer } from "react-notifications";
import { useNavigate } from 'react-router-dom';
import { camelCase, codeTofield } from '../GlobalAssistingFunctions/GlobalAssistingFunctions';
import config from '../../Config.json';

const { candidateRequisitionStatusCode } = config;

function RecentActivities(props) {
    const {
        requisitionId, userType, idContextTest,
        userRecruitmentpartnerId, userRole, userRecords,
        setCurStatus, page, activCount, setactivCount
    } = props;

    const [allCandidate, setAllCandidate] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchActivityCounts();
    }, []);

    const fetchActivityCounts = async () => {
        let user = userType === 'Admin' ? userRole : userType;
        let id = idContextTest;

        if (userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin")) {
            user = userType === 'Admin' ? userRole : userType;
            id = userRecruitmentpartnerId;
        }

        const roleFields = {
            "MIS Operator": "MISId",
            "Recruitment Leader": "RecruitmentLeaderId",
            "Team Leader": "teamLeader",
            "Recruiter": "recruiterId",
            "Organization Admin": "orgId"
        };

        const payload = {
            requisitionId,
            recruitmentpartnerId: userRecruitmentpartnerId,
            [roleFields[user]]: id,
        };

        const response = await countallstatus(payload);
        const statusCounts = response?.data?.statusCounts || {};
        const formattedCounts = {};

        Object.keys(candidateRequisitionStatusCode).forEach(key => {
            const codeKey = candidateRequisitionStatusCode[key];
            const statusKey = codeTofield(codeKey);
            formattedCounts[codeKey] = statusCounts[statusKey]?.count || 0;
        });

        setactivCount(formattedCounts);
    };

    const handleStatusClick = (status) => {
        setAllCandidate(true);
        navigate(`/activity/${requisitionId}`, {
            state: {
                candidateState: status,
                requisitionId,
                status,
                userType,
                userRole,
                userRecruitmentpartnerId,
                userRecords,
                id: idContextTest,
                activCount
            }
        });
        if (page !== "req") setCurStatus(status);
    };

    return (
        <div className="activity-wrapper">
            <div className="activity-card">
                <div className="activity-title">Requisition Activities</div>

                {Object.keys(candidateRequisitionStatusCode).map((label, i) => {
                    const code = candidateRequisitionStatusCode[label];
                    return (
                        <div key={`status-${i}`} className="activity-item" onClick={() => handleStatusClick(code)}>
                            <span className="activity-label">{camelCase(label)}</span>
                            <span className="activity-count">{activCount[code]}</span>
                        </div>
                    );
                })}

                {allCandidate && (
                    <div className="activity-footer">
                        <button className="activity-viewall-btn" onClick={() => handleStatusClick("all")}>
                            View All Candidates
                        </button>
                    </div>
                )}
            </div>

            <NotificationContainer />
        </div>
    );
}

export default RecentActivities;
